/**
 * prepend current date to inner left
 */
(() => {
  const currentYear = new Date().getFullYear();
  const leftElement = document.querySelector('.footer-bottom__inner__left');
  if (leftElement) {
    leftElement.innerHTML = `<span>© ${currentYear} </span>${leftElement.innerHTML}`;
  }
})();
